export default __webpack_public_path__ + "static/media/upload.117ed220.svg";